// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2NO0E","colMin":"styles_colMin__2mkyj"};